import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

import {
  INITIAL_INVITE_GUARDIAN_FORM,
  inviteGuardianSchema,
  type InviteGuardianForm,
} from '@/features/guardian-player/schemas/invite-guardian-schema';

/** react-hook-form instance for the Invite Guardian screen (validated on submit). */
export function useInviteGuardianForm() {
  return useForm<InviteGuardianForm>({
    mode: 'onSubmit',
    resolver: yupResolver(inviteGuardianSchema) as never,
    defaultValues: INITIAL_INVITE_GUARDIAN_FORM,
  });
}

export default useInviteGuardianForm;
